// extracted by mini-css-extract-plugin
export default {"wrapper":"Delivery_wrapper__tfRmk","grid":"Delivery_grid__nKiQT","header":"Delivery_header__21K+d","goBack":"Delivery_goBack__JZ27D","container":"Delivery_container__f3BW4"};